const topicItems = [
  { tag: '国漫崛起', hot: true, count: '12.8k' },
  { tag: '日漫经典', hot: true, count: '10.5k' },
  { tag: '新番推荐', hot: true, count: '9.2k' },
  { tag: '漫改动画', hot: false, count: '8.7k' },
  { tag: '漫画推荐', hot: true, count: '7.9k' },
  { tag: '创作交流', hot: false, count: '6.4k' },
  { tag: '剧情讨论', hot: false, count: '5.8k' },
  { tag: '角色盘点', hot: false, count: '5.1k' },
  { tag: 'CP安利', hot: true, count: '4.6k' },
  { tag: '画风鉴赏', hot: false, count: '4.2k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          漫画爱好者正在热议的话题标签
        </p>
        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topicItems.map((topic, idx) => (
            <div
              key={idx}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all hover:scale-105 ${
                topic.hot
                  ? 'bg-accent-100 text-accent-800 hover:bg-accent-200'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200/70'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
              <span className="text-sm font-medium whitespace-nowrap">
                #{topic.tag}
              </span>
              <span className={`text-xs ${topic.hot ? 'text-accent-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}